import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import LeadForm from "@/pages/LeadForm";
import History from "@/pages/History";
import LeadDetailPage from "@/pages/LeadDetailPage";
import ClienteForm from "@/pages/ClienteForm";
import ClientiHistory from "@/pages/ClientiHistory";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/buyer" element={<LeadForm />} />
          <Route path="/storico" element={<History />} />
          <Route path="/storico/:id" element={<LeadDetailPage endpoint="leads" />} />
          <Route path="/anagrafica" element={<ClienteForm />} />
          <Route path="/anagrafica/elenco" element={<ClientiHistory />} />
          <Route path="/anagrafica/elenco/:id" element={<LeadDetailPage endpoint="clienti" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
